export default __webpack_public_path__ + "static/media/Arm Guards of the Endless Sands.c212188b.jpg";